var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg123(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_3654_5859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09677 15.1935H5.54839V10.5484H4V9H7.09677V15.1935ZM13.8065 13.6452H10.7097V12.6129H12.7742C13.3419 12.6129 13.8065 12.1484 13.8065 11.5806V10.0323C13.8065 9.46452 13.3419 9 12.7742 9H9.16129V10.5484H12.2581V11.5806H10.1935C9.62581 11.5806 9.16129 12.0452 9.16129 12.6129V15.1935H13.8065V13.6452ZM20 14.1613V10.0323C20 9.46452 19.5355 9 18.9677 9H15.3548V10.5484H18.4516V11.5806H16.3871V12.6129H18.4516V13.6452H15.3548V15.1935H18.9677C19.5355 15.1935 20 14.729 20 14.1613Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3654_5859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg123);
export default __webpack_public_path__ + "static/media/123.2446b98e42c9bae7bafac88f46c82896.svg";
export { ForwardRef as ReactComponent };